import { motion } from "framer-motion";
import { EASE_EXPO, VIEWPORT, reveal } from "@/lib/motion";
import { WhatsAppButton } from "./WhatsAppButton";
import { TextReveal } from "@/components/ui/TextReveal";

const steps = [
  {
    n: "01",
    title: "Browse our favorites",
    body:
      "Scroll through what's fresh this week or ask us for the full menu — cakes, cookies, muffins, tins and more.",
  },
  {
    n: "02",
    title: "Message us on WhatsApp",
    body:
      "Tell us what you'd like, when you need it, and any special requests. We'll confirm timing and share the total.",
  },
  {
    n: "03",
    title: "Pick up or get it delivered",
    body:
      "Collect it warm from the kitchen (Delivery currently only available for bulk orders).",
  },
];

export default function HowItWorks() {
  return (
    <section
      id="how-it-works"
      data-testid="how-section"
      className="relative py-12 sm:py-16 md:py-20 bg-[#F2EBE0]"
    >
      <div className="max-w-[1440px] mx-auto px-4 sm:px-8 lg:px-12">
        <div className="mb-6 sm:mb-8 md:mb-10 grid grid-cols-12 gap-4 md:gap-6 items-end">
          <div className="col-span-12 md:col-span-8">
            <span className="text-[11px] uppercase tracking-[0.28em] text-[#C06A22]">
              How ordering works
            </span>
            <TextReveal className="font-serif text-[28px] sm:text-[36px] md:text-5xl lg:text-6xl leading-[1.05] tracking-tight mt-2 text-[#3B2818]">
              Three small steps, then it's on the table.
            </TextReveal>
          </div>
          <p className="col-span-12 md:col-span-4 text-xs sm:text-sm text-[#6B5343] max-w-sm">
            No apps to install, no checkout — just a friendly chat and a fresh
            batch out of the oven.
          </p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-6">
          {/* connector line */}
          <div
            aria-hidden
            className="hidden md:block absolute top-[30px] left-[12%] right-[12%] h-px bg-[#3B2818]/20"
          />
          {steps.map((s, i) => (
            <motion.div
              key={s.n}
              data-testid={`how-step-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={VIEWPORT}
              transition={{ duration: 0.38, delay: i * 0.05, ease: EASE_EXPO }}
              className="relative flex md:flex-col items-start gap-4 md:gap-0"
            >
              <div className="relative bg-[#FAF6F0] w-14 h-14 md:w-16 md:h-16 rounded-full flex items-center justify-center font-serif text-2xl md:text-3xl text-[#C06A22] italic border border-[#3B2818]/15 md:mb-4 shrink-0">
                {s.n}
              </div>
              <div>
                <h3 className="font-serif text-xl md:text-2xl text-[#3B2818] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-1.5 text-xs sm:text-sm text-[#6B5343] leading-relaxed max-w-sm">
                  {s.body}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div {...reveal(0.1)} className="mt-8 sm:mt-10 flex justify-center">
          <WhatsAppButton
            variant="caramel"
            size="lg"
            label="Start on WhatsApp"
            testId="how-wa-cta"
          />
        </motion.div>
      </div>
    </section>
  );
}
